var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('d2-container',[_c('h1',{staticClass:"d2-mt-0"},[_vm._v("该页面尚未完成组件示例搬运")]),_c('p',[_vm._v("D2Admin 的构建依托于由饿了么出品的 ElementUI，欲了解更多该组件的信息请查阅以下链接")]),_c('d2-link-btn',{attrs:{"title":"Element","link":"http://element.eleme.io/#/zh-CN"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }